/**
 * @generated SignedSource<<6e6af97c749cecd75fb6694f970e9f1d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useInitializeLessonBookingWizardLessonType$data = {
  readonly defaultDurationMins?: number;
  readonly durations?: ReadonlyArray<number | null | undefined> | null | undefined;
  readonly id: string;
  readonly rates?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useInitializeLessonBookingWizardLessonType";
};
export type useInitializeLessonBookingWizardLessonType$key = {
  readonly " $data"?: useInitializeLessonBookingWizardLessonType$data;
  readonly " $fragmentSpreads": FragmentRefs<"useInitializeLessonBookingWizardLessonType">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "instructorId"
    },
    {
      "kind": "RootArgument",
      "name": "membershipTypeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useInitializeLessonBookingWizardLessonType",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultDurationMins",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "instructorId",
              "variableName": "instructorId"
            }
          ],
          "kind": "ScalarField",
          "name": "durations",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "items": [
                {
                  "kind": "Variable",
                  "name": "instructorIds.0",
                  "variableName": "instructorId"
                }
              ],
              "kind": "ListValue",
              "name": "instructorIds"
            },
            {
              "kind": "Variable",
              "name": "membershipTypeId",
              "variableName": "membershipTypeId"
            }
          ],
          "concreteType": "LessonRateConnection",
          "kind": "LinkedField",
          "name": "rates",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LessonRateEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LessonRate",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "LessonType",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "6518a632b21baad37bcf49d7b8ac0a9c";

export default node;
